/**
 * Country-code → primary IANA timezone mapping.
 * Covers the most common countries; falls back to "" when unknown.
 */
const COUNTRY_TIMEZONE_MAP: Record<string, string> = {
  IN: "Asia/Kolkata",
  US: "America/New_York",
  GB: "Europe/London",
  SG: "Asia/Singapore",
  AE: "Asia/Dubai",
  AU: "Australia/Sydney",
  CA: "America/Toronto",
  DE: "Europe/Berlin",
  FR: "Europe/Paris",
  JP: "Asia/Tokyo",
  CN: "Asia/Shanghai",
  BR: "America/Sao_Paulo",
  ZA: "Africa/Johannesburg",
  NG: "Africa/Lagos",
  KE: "Africa/Nairobi",
  SA: "Asia/Riyadh",
  QA: "Asia/Qatar",
  KW: "Asia/Kuwait",
  BH: "Asia/Bahrain",
  OM: "Asia/Muscat",
  MY: "Asia/Kuala_Lumpur",
  TH: "Asia/Bangkok",
  VN: "Asia/Ho_Chi_Minh",
  PH: "Asia/Manila",
  ID: "Asia/Jakarta",
  PK: "Asia/Karachi",
  BD: "Asia/Dhaka",
  LK: "Asia/Colombo",
  NP: "Asia/Kathmandu",
  MM: "Asia/Yangon",
  KR: "Asia/Seoul",
  TW: "Asia/Taipei",
  HK: "Asia/Hong_Kong",
  NZ: "Pacific/Auckland",
  MX: "America/Mexico_City",
  AR: "America/Argentina/Buenos_Aires",
  CL: "America/Santiago",
  CO: "America/Bogota",
  PE: "America/Lima",
  EG: "Africa/Cairo",
  IL: "Asia/Jerusalem",
  TR: "Europe/Istanbul",
  RU: "Europe/Moscow",
  UA: "Europe/Kyiv",
  PL: "Europe/Warsaw",
  NL: "Europe/Amsterdam",
  BE: "Europe/Brussels",
  CH: "Europe/Zurich",
  AT: "Europe/Vienna",
  IT: "Europe/Rome",
  ES: "Europe/Madrid",
  PT: "Europe/Lisbon",
  SE: "Europe/Stockholm",
  NO: "Europe/Oslo",
  DK: "Europe/Copenhagen",
  FI: "Europe/Helsinki",
  IE: "Europe/Dublin",
  CZ: "Europe/Prague",
  RO: "Europe/Bucharest",
  GR: "Europe/Athens",
  HU: "Europe/Budapest",
};

/**
 * Returns the primary IANA timezone for a given ISO 3166-1 alpha-2 country code.
 * Returns "" when the country code is unknown.
 */
export function getTimezoneForCountry(countryCode: string): string {
  return COUNTRY_TIMEZONE_MAP[countryCode.toUpperCase()] ?? "";
}

export function validTimezone(value: unknown): string {
  if (typeof value !== "string" || !value.trim()) return "";
  try {
    new Intl.DateTimeFormat("en", { timeZone: value.trim() });
    return value.trim();
  } catch {
    return "";
  }
}

/**
 * Returns all IANA timezone identifiers supported by the current browser,
 * sorted alphabetically.
 */
export function getAllTimezones(): string[] {
  try {
    return (
      (
        Intl as unknown as { supportedValuesOf?: (type: string) => string[] }
      ).supportedValuesOf?.("timeZone") ?? []
    );
  } catch {
    return [];
  }
}
